import { render } from "./SolidTeamingWordLogo.vue?vue&type=template&id=f76ecc1c"
import script from "./SolidTeamingWordLogo.vue?vue&type=script&lang=js"
export * from "./SolidTeamingWordLogo.vue?vue&type=script&lang=js"
script.render = render

export default script